/**
 * Created by Jan Bradac on 29.5.2015.
 * TODO MOBA II - refactor to AJAX namespace. See ajax-response-parser-0.1.js
 */
jQuery.ajaxSetup({
    // Originally
    headers: {
        'X-CSRF-Token' : jQuery('meta[name=_token]').attr('content'),
        'X-AJAX-Request' : true
    }
});
